// Translation
import { useTranslationContext } from '../../context/TranslationContext';
// Components/ui
import { Box, Button, Typography } from '@mui/material';
import { ReminderItem } from './components';
import AddIcon from '@mui/icons-material/Add';
import { ReminderNotificationsContainer, HeaderContainer } from './styles';
// Types
import { UseNotificationsType } from '../../hooks/useNotifications';

type ReminderNotificationsProps = {
  notificationsField: UseNotificationsType;
  disabled: boolean;
};

const ReminderNotifications = ({ notificationsField, disabled }: ReminderNotificationsProps) => {
  const t = useTranslationContext();
  const {
    addNotification,
    deleteNotification,
    handleReminderChange,
    handleTimeFieldChange,
    handleTimePeriodChange,
  } = notificationsField.action;

  const hasNotifications = notificationsField.notifications.length > 0;

  return (
    <ReminderNotificationsContainer>
      <HeaderContainer>
        <Typography
          variant="subtitle2"
          sx={{
            userSelect: 'none',
          }}
        >
          {t('calendarView.reminders.title')}
        </Typography>
        {!disabled && (
          <Button
            disabled={disabled}
            startIcon={<AddIcon />}
            size="small"
            variant="outlined"
            onClick={addNotification}
            color="secondary"
          >
            {t('calendarView.reminders.addReminder')}
          </Button>
        )}
      </HeaderContainer>
      <Box sx={{ pt: 1 }}>
        {hasNotifications ? (
          notificationsField.notifications.map((notification) => (
            <ReminderItem
              key={notification.id}
              data={notification}
              deleteHandler={deleteNotification}
              sendToContactHandler={handleReminderChange}
              timePeriodHandler={handleTimePeriodChange}
              timeValueHandler={handleTimeFieldChange}
              disabled={disabled}
            />
          ))
        ) : disabled ? (
          <Typography variant="body1" sx={{ py: 0.5 }}>
            -
          </Typography>
        ) : null}
      </Box>
    </ReminderNotificationsContainer>
  );
};

export default ReminderNotifications;
